import { Rpc } from "rpc/rpc";
import { ValueWrapper } from "rpc/ValueWrapper";


export class ApiKeyRpc {

    public static get(): Promise<ValueWrapper<string>> {
        return Rpc.GET("/rpc/settings/apikey/get");
    }

    public static generate(): Promise<ValueWrapper<string>> {
        return Rpc.GET("/rpc/settings/apikey/generate");
    }

    public static revoke(): Promise<void> {
        return Rpc.GET("/rpc/settings/apikey/revoke");
    }

    private constructor() {}

}